import React, { useContext, useCallback } from 'react';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';
import appConfig from '@bingads-webui-component-legacy/config';
import { FluctuationPopup } from '@bingads-webui-campaign-react/fluctuation-popup';
import { PerformanceMarkerContext } from '@bingads-webui-campaign-react/performance-marker-provider';

interface useFluctuationPopupProps {
  legacyI18n: any;
  dateRange: { start?: Date; end?: Date; };
  setDismissLastFluctuation: Function;
  navigationLevel: string;
}

export function useFluctuationPopup({
  legacyI18n, dateRange, setDismissLastFluctuation, navigationLevel,
}: useFluctuationPopupProps) {
  const serverContext = useContext(ServerContext) as any;
  const { scope } = useContext(ScopeContext) as any;
  const instrumentation = useContext(InstrumentationContext) as any;
  const perfMarker = useContext(PerformanceMarkerContext);

  return useCallback(({
    fluctuationTypeIds, isOpen, setIsOpen, entity, metric,
  }) => {
    const onFlucDismiss = ({ isLastFluc }) => {
      if (isLastFluc) {
        setDismissLastFluctuation(true);
        setIsOpen(false);
      }
    };

    const context = {
      ...serverContext,
      scope,
      CurrentCampaign: {
        Id: entity ? entity.Id : '',
      },
      isFluctuationsExperiementEnabled: serverContext?.Permissions?.IsFluctuationExperimentEnabled,
    };

    if (navigationLevel === 'customer') {
      context.CurrentCampaign = undefined;
      context.CurrentAccount = { Id: entity ? entity.Id : '' };
    }

    return (
      <FluctuationPopup
        deps={{
          token: serverContext?.Token,
          imagePath: 'https://RESOURCES.UI.BINGADS.MICROSOFT.COM/AdvertiserUI/V2018.1030.2248.41/Application/Images/fluctuation-bulb.png',
          appConfig,
          instrumentation,
          i18n: legacyI18n,
          context,
        }}
        metrics={[metric]}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onFlucDismiss={onFlucDismiss}
        canViewAllInsights
        asyncLoadFluctuationConfig={{ dateRange: { startDate: dateRange?.start, endDate: dateRange?.end }, fluctuationTypeIds }}
        perfMarker={perfMarker}
        withPopoverAdapter={false}
      />
    );
  }, [serverContext, instrumentation, legacyI18n, scope, navigationLevel, dateRange?.start, dateRange?.end, perfMarker, setDismissLastFluctuation]);
}
